const MyBarChart = props => {
  if (props.data.length < 1) {
    return (
      <div className="my-bar-chart">
        No data
      </div>
    )
  }

  return (
    <div className="my-bar-chart">
      {props.data.map(item => item.success > 0 ? (
          <div className="mbc-container" key={item.team} style={{
            position: "relative",
            marginBottom: "5px",
            border: "1px solid #eee"
          }}>
            {item.name}
            <span className="team-percent">({Math.round(100 * item.success / item.total)}%)</span>
            <div className="mbc-success" style={{
              background: props.bg_color_success,
              position: "absolute",
              top: 0,
              width: Math.round(100 * item.success / item.total) + '%',
              height: "100%",
              zIndex: -1
            }}/>
          </div>
        ) : <></>
      )}
    </div>
  )
}

export default MyBarChart
